import { render, staticRenderFns } from "./StudentSelect.vue?vue&type=template&id=4c964d48"
import script from "./StudentSelect.vue?vue&type=script&lang=js"
export * from "./StudentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports